import React, { useEffect, useState } from 'react';
import { Input } from 'antd';
import { CityPostcodeFieldsProps } from '../interfaces';
import './shippingCityAndPostcode.scss';

const ShippingCityPostcode: React.FC<CityPostcodeFieldsProps> = ({
    initialCity,
    initialPostcode,
    onUpdate,
    updateButtonClicked
}) => {
    const [city, setCity] = useState(initialCity);
    const [postcode, setPostcode] = useState(initialPostcode);
    const [isCityTouched, setIsCityTouched] = useState(false);
    const [isPostcodeTouched, setIsPostcodeTouched] = useState(false);
    const [errors, setError] = useState<{ city: boolean; postcode: boolean }>({
        city: false,
        postcode: false,
    });

    const [prevUpdateClicked, setPrevUpdateClicked] = useState(false);

    useEffect(() => {
        setCity(initialCity);
        setPostcode(initialPostcode);
    }, [initialCity, initialPostcode]);

    useEffect(() => {
        const hasCityError = isCityTouched && !city.trim();
        const hasPostcodeError = isPostcodeTouched && !postcode.trim();
        setError({
            city: hasCityError,
            postcode: hasPostcodeError,
        });
    }, [city, postcode, isCityTouched, isPostcodeTouched]);

    useEffect(() => {
        if (updateButtonClicked && !prevUpdateClicked) {
            const hasCityError = !city.trim();
            const hasPostcodeError = !postcode.trim();
            setError({
                city: hasCityError,
                postcode: hasPostcodeError,
            });

            if (!hasCityError && !hasPostcodeError) {
                onUpdate({ city, postcode });
            }

            setPrevUpdateClicked(true);
        } else if (!updateButtonClicked) {
            setPrevUpdateClicked(false);
        }
    }, [updateButtonClicked, prevUpdateClicked, city, postcode, onUpdate]);

    const handleCityChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setCity(value);
        setIsCityTouched(true);
        onUpdate({ city: value, postcode });
    };

    const handlePostcodeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setPostcode(value);
        setIsPostcodeTouched(true);
        onUpdate({ city, postcode: value });
    };

    return (
        <div className="city-postcode-fields">
            <div className="input-container">
                <label htmlFor="city" className="input-label">City</label>
                <Input
                    id="city"
                    name="city"
                    value={city}
                    onChange={handleCityChange}
                    status={errors.city ? 'error' : undefined}
                />
            </div>
            <div className="input-container">
                <label htmlFor="postcode" className="input-label-second">Postcode</label>
                <Input
                    id="postcode"
                    name="postcode"
                    value={postcode}
                    onChange={handlePostcodeChange}
                    status={errors.postcode ? 'error' : undefined}
                />
            </div>
        </div>
    );
};

export default ShippingCityPostcode;
